import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { getRecentAdminActivity } from "../api/adminActivity";
import type { RecentAdminActivityParams } from "../api/adminActivity";

export function useRecentAdminActivity(params: RecentAdminActivityParams) {
  return useQuery({
    queryKey: ["admin-activity", "recent", params.offset, params.limit],
    queryFn: () => getRecentAdminActivity(params),
    placeholderData: keepPreviousData,
    refetchOnMount: "always",
  });
}
